import React, { useContext } from "react";
import {
  Button,
  Typography,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";

import FormControl, { TextFieldControl } from "components/FormControl";
import LoadingButton from "components/LoadingButton";
import Row from "components/Form/Row";
import { Field } from "react-final-form";

import { Container, TitleContainer, Buttons, ButtonContainer } from "./styles";

import FormContext from "components/FormControl/formContext";
import SubmitButtonControl from "components/FormControl/SubmitButtonControl";

type Props = {
  onClose: () => void;
  onSubmit: (values: any) => void;
  initialValues?: {
    title?: string;
    id?: number;
    showFirstWeekly?: boolean;
  };
  isLoading?: boolean;
};

const SequenceForm: React.FC<Props> = ({
  onClose,
  onSubmit,
  initialValues = {},
  isLoading = false,
}) => {
  const defaultValues = {
    title: "",
    showFirstWeekly: false,
    ...initialValues,
  };

  const validateTitle = (value: string) => {
    if (!value || value.trim() === "") {
      return "This field is required.";
    }
    if (value.trim().length < 3) {
      return "Title must be at least 3 characters.";
    }
    return undefined;
  };

  return (
    <FormControl onSubmit={onSubmit} initialValues={defaultValues}>
      <FormWithContext
        onClose={onClose}
        isLoading={isLoading}
        validateTitle={validateTitle}
        hasInitialTitle={!!initialValues?.title}
      />
    </FormControl>
  );
};

const FormWithContext = ({
  onClose,
  isLoading,
  validateTitle,
  hasInitialTitle,
}: {
  onClose: () => void;
  isLoading: boolean;
  validateTitle: (value: string) => string | undefined;
  hasInitialTitle: boolean;
}) => {
  const form = useContext(FormContext);

  const renderButton = ({ onClick }: { onClick: () => void }) => (
    <LoadingButton
      onClick={onClick}
      variant="contained"
      color="primary"
      fullWidth
      isLoading={isLoading}
    >
      {hasInitialTitle ? "Save" : "Add"}
    </LoadingButton>
  );

  return (
    <form onSubmit={form.handleSubmit}>
      <Container>
        <TitleContainer>
          <Typography variant="h1" color="textPrimary">
            {hasInitialTitle ? "Edit Sequence" : "Add Sequence"}
          </Typography>
        </TitleContainer>

        <Row>
          <TextFieldControl
            variant="outlined"
            margin="none"
            label="Title *"
            name="title"
            placeholder="Enter sequence title"
            validate={validateTitle}
            fullWidth
          />
        </Row>
        <Row>
          <Field name="showFirstWeekly" type="checkbox">
            {({ input }) => (
              <FormControlLabel
                control={<Checkbox {...input} color="primary" />}
                label="Show Sequence first"
              />
            )}
          </Field>
        </Row>
        <Typography
          variant="subtitle1"
          color="textSecondary"
          style={{ marginTop: -50, fontSize: 12 }}
        >
          If checked, sequences are shown first when weekly workouts are
          scheduled.
          <br />
          If unchecked, sequences are shown after the weekly workouts.
        </Typography>
      </Container>

      <Buttons>
        <ButtonContainer>
          <Button
            variant="outlined"
            color="primary"
            onClick={onClose}
            fullWidth
          >
            Cancel
          </Button>
        </ButtonContainer>
        <ButtonContainer>
          <SubmitButtonControl render={renderButton} />
        </ButtonContainer>
      </Buttons>
    </form>
  );
};

export default SequenceForm;
